import { render, staticRenderFns } from "./sbDetails.vue?vue&type=template&id=9ec22d42&scoped=true"
import script from "./sbDetails.vue?vue&type=script&lang=ts"
export * from "./sbDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec22d42",
  null
  
)

export default component.exports